<script setup>
import { onMounted } from 'vue'

onMounted(() => {
  window.addEventListener('load', function (){
    (window.adsbygoogle = window.adsbygoogle || []).push({});
  })
})
</script>

<template>
  <div class="left-bar-advertisement">
    <ins class="adsbygoogle"
         style="display:inline-block;width:120px;height:600px"
         data-ad-client="ca-pub-4924970657092834"
         data-ad-slot="7886115832"></ins>
  </div>
</template>

<style lang="scss" scoped>
.left-bar-advertisement {
  position: fixed;
  top: 50%;
  transform: translate(0, -50%);
}
</style>
